import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

interface LoaderContextShape {
    load: (loading: boolean, label?: string) => void;
}

export const LoaderContext = createContext<LoaderContextShape>({
    load: () => {},
});

export function useLoader() {
    return useContext(LoaderContext);
}

export interface LoaderComponentProps {
    loading: boolean;
    label?: string;
}

interface LoaderProviderProps {
    component: React.ComponentType<LoaderComponentProps>;
    timeout?: number;
}

export const LoaderProvider: React.FC<LoaderProviderProps> = ({ component: Loader, timeout = 1500, children }) => {
    const [loading, setLoading] = useState(false);
    const [label, setLabel] = useState<string | undefined>();

    const load = useCallback((loading, label) => {
        setLoading(loading);
        setLabel(label);
    }, []);

    // Loader Timeout
    useEffect(() => {
        if (loading) {
            setTimeout(() => {
                setLoading(false);
            }, timeout);
        }
    }, [loading, timeout]);

    return (
        <>
            <LoaderContext.Provider value={{ load }} children={children} />
            <Loader loading={loading} label={label} />
        </>
    );
};

export default LoaderProvider;
